import React, { Component } from "react";
import { ErrorCode, INTERMEDIATE_OUTPUT_FILES } from "../../../../const";
import { v4 as uuidv4 } from "uuid";
import Alert from "sweetalert-react";
import * as Http from "../../../../http";
import * as Business from "../../../../utils/business";
import Loading from "../../../../components/Loading";
import {
  ProgressBar,
  MenuItem,
  DropdownButton,
  FormGroup,
  FormControl,
  InputGroup,
  Button,
  Table,
  ControlLabel,
} from "react-bootstrap";
import UpdateNameAndReportDateModalModal from "../../../../components/UpdateNameAndReportDate";

const dicSingleConsol = {
  single: "SINGLE",
  consol: "CONSOL",
};

const dicFilterModule = {
  cr_cor: "CR COR",
  mr_ccr: "MR CCR",
  or: "OR",
  irrbb_lr: "IRRBB LR",
};

const dicFilterPeriods = {
  all: "All",
  none: "None",
  t0: "T0",
  t1: "T1",
  t2: "T2",
  t3: "T3",
};
const dicFilterScenario = {
  all: "All",
  none: "None",
};

const dicScenario = {
  lowest_car: "CAR thấp nhất",
  lowest_lev: "LEV thấp nhất",
};

class FileInfo extends Component {
  constructor(props) {
    super(props);
    const fileInfo = props.location.state || {};
    const lstInputFiles = fileInfo.input_files
      ? JSON.parse(fileInfo.input_files)
      : [];
    this.state = {
      singleConsol: "single",
      scenario: "lowest_car",
      filterIntermediateOutput: {
        scenario: "all",
        period: "all",
        module: "cr_cor",
      },
      isShowUpdateNameAndReportDateModal: false,
      isSelectAllInput: false,
      isSelectAllOutput: false,
      isSelectAlIntermediateOutput: false,
      fileInfo: fileInfo,
      lstInput: lstInputFiles.map((e) => ({
        input: e.name,
        upload_by: fileInfo.upload_by,
        upload_time: Business.convertToFullDate(fileInfo.upload_time),
      })),
      lstOutput: [],
      dicIntermediateOutputByFilter: {},
      lstIntermediateOutput: [],
      failedDownloadsList: [],
      reportDate: Business.convertToDate(fileInfo.report_date),
      reportName: fileInfo.file_name || "",
      status: Business.convertFileStatus(fileInfo.status),
      reason: fileInfo.reason,
      loading: false,
      hasResult: false,
      showRejectAlert: false,
      showFileDownloadError: false,
      isDisableRejectButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableApprovalButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableReasonInput:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableCalculateButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.APPROVED &&
        fileInfo.status !== Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
    };
  }

  listReportWillDelete = null;

  componentDidMount() {
    clearGetBatchDownloadInterval();
    Http.getListScenarios(this.state.reportDate, this.state.reportName).then(
      (data) => {
        if (data && data.Success && data.Data) {
          for (let i = 0; i < data.Data.length; i++) {
            dicScenario[data.Data[i].toLowerCase()] =
              data.Data[i].toUpperCase();
            dicFilterScenario[data.Data[i].toLowerCase()] =
              data.Data[i].toUpperCase();
          }
        }
        if (
          this.state.fileInfo.status === Business.ENUMS.FILE_STATUS.CALCULATED
        ) {
          this.getReportList();
        } else {
          this.setState({ loading: false });
        }
      },
    );
  }

  mappingDicIntermediateOutputByFilter = (lstIntermediateOutput) => {
    const dicIntermediateOutputByFilter = {};
    if (lstIntermediateOutput && lstIntermediateOutput.length > 0) {
      for (let i = 0; i < lstIntermediateOutput.length; i++) {
        const item = lstIntermediateOutput[i];
        const report_name = `${item.report_name}`.toLowerCase();

        const isContain = (array, reportName) => {
          let result = false;
          array.forEach((s) => {
            if (`${reportName}`.toLowerCase().includes(`${s}`.toLowerCase())) {
              result = true;
              return;
            }
          });
          return result;
        };

        let module = "";
        if (isContain(INTERMEDIATE_OUTPUT_FILES.CR_COR, report_name)) {
          module = "cr_cor";
        } else if (isContain(INTERMEDIATE_OUTPUT_FILES.MR_CCR, report_name)) {
          module = "mr_ccr";
        } else if (isContain(INTERMEDIATE_OUTPUT_FILES.OR, report_name)) {
          module = "or";
        } else {
          module = "irrbb_lr";
        }

        if (!dicIntermediateOutputByFilter[`${module}_all_all`])
          dicIntermediateOutputByFilter[`${module}_all_all`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_none`])
          dicIntermediateOutputByFilter[`${module}_all_none`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t0`])
          dicIntermediateOutputByFilter[`${module}_all_t0`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t1`])
          dicIntermediateOutputByFilter[`${module}_all_t1`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t2`])
          dicIntermediateOutputByFilter[`${module}_all_t2`] = {};
        if (!dicIntermediateOutputByFilter[`${module}_all_t3`])
          dicIntermediateOutputByFilter[`${module}_all_t3`] = {};
        let isHasScenario = false;
        Object.keys(dicFilterScenario).forEach((s) => {
          if (s === "all") return;
          if (!dicIntermediateOutputByFilter[`${module}_${s}_all`])
            dicIntermediateOutputByFilter[`${module}_${s}_all`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_none`])
            dicIntermediateOutputByFilter[`${module}_${s}_none`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t0`])
            dicIntermediateOutputByFilter[`${module}_${s}_t0`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t1`])
            dicIntermediateOutputByFilter[`${module}_${s}_t1`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t2`])
            dicIntermediateOutputByFilter[`${module}_${s}_t2`] = {};
          if (!dicIntermediateOutputByFilter[`${module}_${s}_t3`])
            dicIntermediateOutputByFilter[`${module}_${s}_t3`] = {};
          if (report_name.includes(`_${s}_`)) {
            dicIntermediateOutputByFilter[`${module}_all_all`][report_name] =
              item;
            dicIntermediateOutputByFilter[`${module}_${s}_all`][report_name] =
              item;
            if (report_name.includes(`_t0_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t0`][report_name] =
                item;
              dicIntermediateOutputByFilter[`${module}_all_t0`][report_name] =
                item;
            } else if (report_name.includes(`_t1_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t1`][report_name] =
                item;
              dicIntermediateOutputByFilter[`${module}_all_t1`][report_name] =
                item;
            } else if (report_name.includes(`_t2_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t2`][report_name] =
                item;
              dicIntermediateOutputByFilter[`${module}_all_t2`][report_name] =
                item;
            } else if (report_name.includes(`_t3_`)) {
              dicIntermediateOutputByFilter[`${module}_${s}_t3`][report_name] =
                item;
              dicIntermediateOutputByFilter[`${module}_all_t3`][report_name] =
                item;
            } else {
              dicIntermediateOutputByFilter[`${module}_${s}_none`][
                report_name
              ] = item;
              dicIntermediateOutputByFilter[`${module}_all_none`][report_name] =
                item;
            }
            isHasScenario = true;
          }
        });
        if (!isHasScenario) {
          dicIntermediateOutputByFilter[`${module}_all_all`][report_name] =
            item;
          dicIntermediateOutputByFilter[`${module}_none_all`][report_name] =
            item;
          if (report_name.includes(`_t0_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t0`][report_name] =
              item;
          } else if (report_name.includes(`_t1_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t1`][report_name] =
              item;
          } else if (report_name.includes(`_t2_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t2`][report_name] =
              item;
          } else if (report_name.includes(`_t3_`)) {
            dicIntermediateOutputByFilter[`${module}_all_t3`][report_name] =
              item;
          } else {
            dicIntermediateOutputByFilter[`${module}_none_none`][report_name] =
              item;
            dicIntermediateOutputByFilter[`${module}_all_none`][report_name] =
              item;
          }
        }
      }
    }
    return dicIntermediateOutputByFilter;
  };

  getReportList = () => {
    Http.getListReport(
      Business.COMPONENT.LR,
      this.state.fileInfo.file_name,
    ).then((data) => {
      const lstOutput = [];
      const lstIntermediateOutput = [];
      if (data && data.Success && data.Data) {
        data.Data.forEach((item) => {
          const isLiquidityFinalReport = /LIQ1/i.test(item.report_name || "");
          if (!Business.isOutputFile(item.report_name) && !isLiquidityFinalReport) return;
          item.created = Business.convertToFullDate(item.created);
          if (Business.isIntermediateOutputFiles(item.report_name)) {
            lstIntermediateOutput.push(item);
          } else {
            lstOutput.push(item);
          }
        });
      }
      const dicIntermediateOutputByFilter =
        this.mappingDicIntermediateOutputByFilter(lstIntermediateOutput);
      this.setState(
        {
          lstOutput: lstOutput,
          lstIntermediateOutput: lstIntermediateOutput,
          dicIntermediateOutputByFilter: dicIntermediateOutputByFilter,
          loading: false,
        },
        () => {
          this.onChangeFilterIntermediateOutput();
        },
      );
    });
  };

  onReject = () => {
    this.setState({ showRejectAlert: true });
  };

  onConfirmReject = () => {
    Http.updateUploadInfo(
      Business.COMPONENT.LR,
      this.state.reportDate,
      this.state.reportName,
      Business.ENUMS.FILE_STATUS.REJECTED,
      this.state.reason,
    ).then((res) => {
      if (!res) {
        Business.showAlert({ title: "Error", content: "Unknow Error" });
      } else {
        if (res.Success) {
          Business.showAlert({ title: "Info", content: "Successfully" });
          this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.REJECTED);
          this.setState({
            status: Business.convertFileStatus(
              Business.ENUMS.FILE_STATUS.REJECTED,
            ),
          });
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: "Error",
                content: "You are not permission",
              });
            default:
              Business.showAlert({ title: "Error", content: "Unknow Error" });
          }
        }
      }
    });
    this.setState({ showRejectAlert: false });
  };

  onApproval = () => {
    Http.updateUploadInfo(
      Business.COMPONENT.LR,
      this.state.reportDate,
      this.state.reportName,
      Business.ENUMS.FILE_STATUS.APPROVED,
      null,
    ).then((res) => {
      if (!res) {
        Business.showAlert({ title: "Error", content: "Unknow Error" });
      } else {
        if (res.Success) {
          Business.showAlert({ title: "Info", content: "Successfully" });
          this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.APPROVED);
          this.setState({
            status: Business.convertFileStatus(
              Business.ENUMS.FILE_STATUS.APPROVED,
            ),
          });
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: "Error",
                content: "You are not permission",
              });
            default:
              Business.showAlert({ title: "Error", content: "Unknow Error" });
          }
        }
      }
    });
    this.setState({ showRejectAlert: false });
  };

  onCalculate = async () => {
    const isCalculating = await Business.hasBatchCalculating();
    if (isCalculating) {
      Business.showAlert({
        title: "Error",
        content: "The system is busy. Please try again in a few moments.",
      });
      return;
    }

    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATING);
    this.setState({
      loading: true,
      errorCode: ErrorCode.PendingBatchProcessing,
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATING,
      ),
    });
    Http.calculate(
      this.state.reportDate,
      this.state.reportName,
      this.state.singleConsol,
      this.state.scenario,
      true,
      Business.COMPONENT.LR,
    ).then((res) => {
      this.setState({ loading: false });
      if (res && res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        this.onGetBatchResponse();
      } else {
        this.handleCalculateResponse(res);
      }
    });
  };

  onSelectInput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllInput === true) {
        this.setState({ isSelectAllInput: false });
        this.state.lstInput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllInput: true });
        this.state.lstInput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstInput.map((item) => {
        if (item.input === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onSelectOutput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllOutput === true) {
        this.setState({ isSelectAllOutput: false });
        this.state.lstOutput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllOutput: true });
        this.state.lstOutput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstOutput.map((item) => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onSelectIntermediateOutput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAlIntermediateOutput === true) {
        this.setState({ isSelectAlIntermediateOutput: false });
        this.state.lstIntermediateOutput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAlIntermediateOutput: true });
        this.state.lstIntermediateOutput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstIntermediateOutput.map((item) => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onDownloadInputFiles = async () => {
    const lstFileSelected = [];
    if (this.state.lstInput && this.state.lstInput.length > 0) {
      for (let i = 0; i < this.state.lstInput.length; i++) {
        const item = this.state.lstInput[i];
        if (item.select === true) {
          lstFileSelected.push(item.input);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({ loading: true });
      await handleBatchDownload(
        this.state.fileInfo,
        lstFileSelected,
        this.state.reportDate,
        this.state.reportName,
        "input_calculation",
        Business.COMPONENT.LR,
        (message) => {
          if (message) {
            this.setState({ downloadProgressMessage: message });
          } else {
            this.setState({ downloadProgressMessage: "", loading: false });
          }
        },
      );
    }
  };

  onDownloadOutputFiles = async () => {
    const lstFileSelected = [];
    if (this.state.lstOutput && this.state.lstOutput.length > 0) {
      for (let i = 0; i < this.state.lstOutput.length; i++) {
        const item = this.state.lstOutput[i];
        if (item.select === true) {
          lstFileSelected.push(item.report_name);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({ loading: true });
      await handleBatchDownload(
        this.state.fileInfo,
        lstFileSelected,
        this.state.reportDate,
        this.state.reportName,
        null,
        Business.COMPONENT.LR,
        (message) => {
          if (message) {
            this.setState({ downloadProgressMessage: message });
          } else {
            this.setState({ downloadProgressMessage: "", loading: false });
          }
        },
      );
    }
  };

  onDownloadIntermediateOutputFiles = async () => {
    const lstFileSelected = [];
    if (
      this.state.lstIntermediateOutput &&
      this.state.lstIntermediateOutput.length > 0
    ) {
      for (let i = 0; i < this.state.lstIntermediateOutput.length; i++) {
        const item = this.state.lstIntermediateOutput[i];
        if (item.select === true) {
          lstFileSelected.push(item.report_name);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      this.setState({ loading: true });
      await handleBatchDownload(
        this.state.fileInfo,
        lstFileSelected,
        this.state.reportDate,
        this.state.reportName,
        null,
        Business.COMPONENT.LR,
        (message) => {
          if (message) {
            this.setState({ downloadProgressMessage: message });
          } else {
            this.setState({ downloadProgressMessage: "", loading: false });
          }
        },
      );
    }
  };

  onGetBatchResponse = () => {
    const intervalId = setInterval(() => {
      console.warn(`${this.state.reportName} | Request to get batch response`);
      Http.getBatchResult(this.state.reportDate, this.state.reportName).then(
        (res) => {
          this.handleGetBatchUploadingResponse(res);
        },
      );
    }, 3000);
    lstIntervalId.push(intervalId);
  };

  handleHideShowBtn(statusOfBatch) {
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.REJECTED) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
    if (
      statusOfBatch === Business.ENUMS.FILE_STATUS.APPROVED ||
      statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED
    ) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: false,
      });
    }
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATING) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
  }

  handleErrorCode(res) {
    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED);
    this.setState({
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
      ),
    });
    console.log(`Response: ${JSON.stringify(res || {})}`);
    if (res) {
      switch (res.ErrorCode) {
        case ErrorCode.PermissionDenie:
          Business.showAlert({
            title: "Error",
            content: "You are not permission",
          });
          break;
        case ErrorCode.Empty:
          Business.showAlert({ title: "Error", content: "File is empty" });
          break;
        case ErrorCode.Exist:
          Business.showAlert({
            title: "Error",
            content: "Name already exists in the system",
          });
          break;
        case ErrorCode.DataInvalid:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        case ErrorCode.UnknowError:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        default:
          Business.showAlert({
            title: "Error",
            content: res.Data || "Unknow Error",
          });
          break;
      }
    } else {
      Business.showAlert({ title: "Error", content: "Unknow Error" });
    }
  }

  handleCalculateResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.Success) {
      const data = res.Data || {};
      this.setState({
        hasResult: true,
        icaapConsolReport: data,
      });
    } else {
      this.handleErrorCode(res);
    }
  };

  handleGetBatchUploadingResponse = (res) => {
    if (res) {
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        console.warn(
          `${this.state.reportName} | Received state: PendingBatchProcessing`,
        );
      } else {
        console.warn(`${this.state.reportName} | Received state: Success`);
        const errorCode = res ? res.ErrorCode : null;
        this.setState({ errorCode });
        if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
          clearGetBatchResponseInterval(this.state.reportName);
        }
        if (res && res.Success) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            // console.warn('Received state: PendingBatchProcessing');
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchResponseInterval(this.state.reportName);
            console.warn("Received state: BatchEmpty");
          } else {
            const data = res.Data || {};
            this.getReportList();
            this.setState({
              hasResult: true,
              icaapConsolReport: data,
              status: Business.convertFileStatus(
                Business.ENUMS.FILE_STATUS.CALCULATED,
              ),
            });
          }
        } else {
          this.handleErrorCode(res);
        }
      }
    }
  };

  renderPendingBatchProcessing = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
              paddingTop: "50px",
            }}
            className="title"
          >
            The system is calculating. Please wait...
          </h4>
        </div>
      </div>
    );
  };

  renderResult = () => {
    const report = this.state.icaapConsolReport || {};
    const lcrResult = (report && report.LCR_RESULT) || {};
    const toB = (v) =>
      v == null || v === undefined ? "-" : (v / 1e9).toFixed(4);
    const toPct = (v) =>
      v == null || v === undefined ? "-" : ((v || 0) * 100).toFixed(4) + "%";
    const summaryCards = [
      {
        title: "HQLA hiệu dụng",
        value: `${toB(lcrResult.f_hqla)} tỷ đ`,
        tone: "#e6f7ff",
      },
      {
        title: "Dòng tiền ra ròng",
        value: `${toB(lcrResult.n_net_cash_outflows)} tỷ đ`,
        tone: "#fff7e6",
      },
      {
        title: "Tỷ lệ LCR",
        value: toPct(lcrResult.n_liquidity_coverage_ratio),
        tone: "#f6ffed",
      },
    ];

    return (
      <div style={{ animation: "lrFadeInUp .4s ease-out" }}>
        <style>
          {`@keyframes lrFadeInUp { from { opacity: 0; transform: translateY(12px);} to {opacity: 1; transform: translateY(0);} }`}
        </style>
        <div style={{ height: "20px" }} />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 12,
            marginBottom: 16,
          }}
        >
          {summaryCards.map((card) => (
            <div
              key={card.title}
              style={{
                background: card.tone,
                borderRadius: 10,
                padding: 14,
                border: "1px solid #f0f0f0",
              }}
            >
              <div style={{ color: "#595959", fontSize: 13 }}>{card.title}</div>
              <div style={{ fontSize: 22, fontWeight: 700, marginTop: 4 }}>
                {card.value}
              </div>
            </div>
          ))}
        </div>

        <div
          style={{
            border: "1px solid #f0f0f0",
            borderRadius: 10,
            overflow: "hidden",
            boxShadow: "0 6px 20px rgba(0,0,0,.05)",
          }}
        >
          <Table striped bordered hover style={{ marginBottom: 0 }}>
            <thead>
              <tr>
                <th style={style.bolder}>STT</th>
                <th style={style.bolder}>Chi tiêu</th>
                <th style={style.bolder}>Đơn vị</th>
                <th style={style.bolder}>Giá trị (tỷ đồng)</th>
              </tr>
            </thead>
            <tbody>
              <tr><td colSpan={4} style={{ ...style.bolder, background: '#e8f0fe' }}>I. Tài sản có tính thanh khoản cao (HQLA)</td></tr>
              <tr><td>1</td><td>Tiền và tương đương (IN_GL)</td><td>tỷ đ</td><td>{toB(lcrResult.n_coin_banknotes)}</td></tr>
              <tr><td>2</td><td>Dự trữ NHNN (IN_GL)</td><td>tỷ đ</td><td>{toB(lcrResult.n_central_bank_reserves)}</td></tr>
              <tr><td>3</td><td>Trái phiếu Chính phủ/NHNN (HQLA Cấp 1)</td><td>tỷ đ</td><td>{toB(lcrResult.n_domestic_sovereign_debt)}</td></tr>
              <tr><td>4</td><td>Cổ phiếu chỉ số (HQLA Cấp 2B, gross)</td><td>tỷ đ</td><td>{toB(lcrResult.n_common_equity)}</td></tr>
              <tr style={{ fontWeight: 'bold' }}><td /><td>Tổng HQLA hiệu dụng (sau hệ số và cap)</td><td>tỷ đ</td><td>{toB(lcrResult.f_hqla)}</td></tr>

              <tr><td colSpan={4} style={{ ...style.bolder, background: '#fff3cd' }}>II. Dòng tiền ra</td></tr>
              <tr><td>1</td><td>Tiền gửi cá nhân ổn định (≤30d, VND)</td><td>tỷ đ</td><td>{toB(lcrResult.n_stable_retail_deposits)}</td></tr>
              <tr><td>2</td><td>Tiền gửi cá nhân kém ổn định (≤30d, VND)</td><td>tỷ đ</td><td>{toB(lcrResult.n_less_stable_retail_deposits)}</td></tr>
              <tr><td>3</td><td>Tiền gửi CKH cá nhân >30 ngày (có phạt rút sớm)</td><td>tỷ đ</td><td>{toB(lcrResult.n_not_withdrawal_term_retail_deposits)}</td></tr>
              <tr><td>4</td><td>Tiền gửi vận hành TCTD không bảo hiểm (25%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_not_insured_cib_ope_deposits)}</td></tr>
              <tr><td>5</td><td>Tiền gửi phi vận hành / DN phi TC (40%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_non_operational_deposits)}</td></tr>
              <tr><td>6</td><td>Huy động từ TCTD khác (100%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_fi_deposits)}</td></tr>
              <tr><td>7</td><td>Vay có đảm bảo HQLA Cấp 1 - factor 0%</td><td>tỷ đ</td><td>{toB(lcrResult.n_funding_backed_by_level1_assets)}</td></tr>
              <tr><td>8</td><td>Vay có đảm bảo Chính phủ (25%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_secured_funding_sovereign)}</td></tr>
              <tr><td>9</td><td>Vay có đảm bảo khác (100%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_other_secured_funding)}</td></tr>
              <tr><td>10</td><td>Thay đổi GTTSĐB phái sinh (100%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_derivatives_market_value_change)}</td></tr>
              <tr><td>11</td><td>Hạn mức chưa giải ngân - Cá nhân (5%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_undrawn_retail_and_small_business)}</td></tr>
              <tr><td>12</td><td>Hạn mức - Corp/CP tín dụng (10%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_undrawn_sovereign_credit)}</td></tr>
              <tr><td>13</td><td>Hạn mức - Corp/CP thanh khoản (30%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_undrawn_sovereign_liquidity)}</td></tr>
              <tr><td>14</td><td>Hạn mức - TCTD (40%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_undrawn_bank_facilities)}</td></tr>
              <tr><td>15</td><td>Hạn mức - TCTC tín dụng (40%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_undrawn_fi_credit)}</td></tr>
              <tr><td>16</td><td>Hạn mức - TCTC thanh khoản (100%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_undrawn_fi_liquidity)}</td></tr>
              <tr><td>17</td><td>Phải trả ròng phái sinh (100%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_derivative_payables)}</td></tr>
              <tr><td>18</td><td>Lãi dồn tích + Nghĩa vụ khác (100%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_other_contractual_cash_flows)}</td></tr>
              <tr style={{ fontWeight: 'bold' }}><td /><td>Tổng dòng tiền ra hiệu dụng (sau hệ số)</td><td>tỷ đ</td><td>{toB(lcrResult.f_outflow)}</td></tr>

              <tr><td colSpan={4} style={{ ...style.bolder, background: '#d4edda' }}>III. Dòng tiền vào</td></tr>
              <tr><td>1</td><td>Cho vay có đảm bảo HQLA Cấp 1 (≤30d) - 0%</td><td>tỷ đ</td><td>{toB(lcrResult.n_level1_assets)}</td></tr>
              <tr><td>2</td><td>Cho vay có đảm bảo HQLA Cấp 2B (≤30d) - 50%</td><td>tỷ đ</td><td>{toB(lcrResult.n_other_level_2b_assets)}</td></tr>
              <tr><td>3</td><td>Cho vay có đảm bảo khác (≤30d) - 100%</td><td>tỷ đ</td><td>{toB(lcrResult.n_other_assets)}</td></tr>
              <tr><td>4</td><td>Tín dụng quay vòng (0%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_revolving_credit)}</td></tr>
              <tr><td>5</td><td>Tiền gửi vận hành tại TCTD (0%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_operational_deposits)}</td></tr>
              <tr><td>6</td><td>Khoản phải thu KHCN (50%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_retail_counterparty_receivables)}</td></tr>
              <tr><td>7</td><td>Khoản phải thu KH bán buôn (50%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_wholesale_counterparty_receivables)}</td></tr>
              <tr><td>8</td><td>Khoản phải thu TCTD (100%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_other_counterparty_receivables)}</td></tr>
              <tr><td>9</td><td>Phải thu ròng phái sinh (100%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_net_derivative_receivables)}</td></tr>
              <tr><td>10</td><td>Dòng tiền vào hợp đồng khác (100%)</td><td>tỷ đ</td><td>{toB(lcrResult.n_other_contractual_cash_inflows)}</td></tr>
              <tr style={{ fontWeight: 'bold' }}><td /><td>Tổng dòng tiền vào hiệu dụng (sau hệ số)</td><td>tỷ đ</td><td>{toB(lcrResult.f_inflow)}</td></tr>

              <tr><td colSpan={4} style={{ ...style.bolder, background: '#cce5ff' }}>IV. Kết quả LCR</td></tr>
              <tr style={{ fontWeight: 'bold' }}><td>1</td><td>Tổng HQLA hiệu dụng</td><td>tỷ đ</td><td>{toB(lcrResult.f_hqla)}</td></tr>
              <tr style={{ fontWeight: 'bold' }}><td>2</td><td>Tổng dòng tiền ra ròng</td><td>tỷ đ</td><td>{toB(lcrResult.n_net_cash_outflows)}</td></tr>
              <tr style={{ fontWeight: 'bold', fontSize: '1.1em', color: '#0056b3' }}>
                <td>3</td><td>Tỷ lệ đảm bảo thanh khoản (LCR)</td><td>%</td><td>{toPct(lcrResult.n_liquidity_coverage_ratio)}</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    );
  };

  handleSelectSingleConsolMethod = (eventKey, event) => {
    this.setState({ singleConsol: eventKey });
  };

  handleSelectFilterModuleMethod = (eventKey, event) => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    filterIntermediateOutput.module = eventKey;
    this.setState({ filterIntermediateOutput }, () => {
      this.onChangeFilterIntermediateOutput();
    });
  };

  handleSelectFilterPeriodsMethod = (eventKey, event) => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    filterIntermediateOutput.period = eventKey;
    this.setState({ filterIntermediateOutput }, () => {
      this.onChangeFilterIntermediateOutput();
    });
  };

  handleSelectFilterSecenariosMethod = (eventKey, event) => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    filterIntermediateOutput.scenario = eventKey;
    this.setState({ filterIntermediateOutput }, () => {
      this.onChangeFilterIntermediateOutput();
    });
  };

  onChangeFilterIntermediateOutput = () => {
    const filterIntermediateOutput = this.state.filterIntermediateOutput;
    const dicIntermediateOutputByFilter =
      this.state.dicIntermediateOutputByFilter;
    const { module, scenario, period } = filterIntermediateOutput;

    const lstIntermediateOutput = Object.values(
      dicIntermediateOutputByFilter[`${module}_${scenario}_${period}`] || {},
    );
    this.setState({ lstIntermediateOutput: lstIntermediateOutput });
  };

  handleSelectScenario = (eventKey, event) => {
    this.setState({ scenario: eventKey });
  };

  onShowUpdateNameAndReportDateModal = () => {
    this.setState({
      isShowUpdateNameAndReportDateModal: true,
    });
  };

  onCloseUpdateNameAndReportDateModal = () => {
    this.setState({
      isShowUpdateNameAndReportDateModal: false,
    });
  };

  onCloseUpdateNameAndReportDateModalAndGetNewData = (
    reportDate,
    reportName,
  ) => {
    const objSearch = {
      report_date: reportDate,
      file_name: reportName,
    };

    Http.getUploadManagement(Business.COMPONENT.LR, objSearch).then((data) => {
      if (data && data.Success) {
        if (data.Data && data.Data.length === 1) {
          const fileInfo = data.Data[0];
          Business.showAlert({
            title: "Info",
            content: "Update successfully",
          });
          this.setState({
            fileInfo: fileInfo,
            reportDate: Business.convertToDate(fileInfo.report_date),
            reportName: fileInfo.file_name || "",
          });
        }
      }
    });

    this.setState({
      isShowUpdateNameAndReportDateModal: false,
    });
  };

  renderUpdateNameAndReportDateModal = () => {
    return (
      <UpdateNameAndReportDateModalModal
        component={"ICAAP"}
        reportDate={this.state.reportDate}
        reportName={this.state.reportName}
        isShowUpdateNameAndReportDateModal={
          this.state.isShowUpdateNameAndReportDateModal
        }
        onCloseUpdateNameAndReportDateModal={
          this.onCloseUpdateNameAndReportDateModal
        }
        onCloseUpdateNameAndReportDateModalAndGetNewData={
          this.onCloseUpdateNameAndReportDateModalAndGetNewData
        }
      />
    );
  };

  renderBtnUpdateNameAndReportDate = () => {
    return (
      <i
        style={{ fontSize: 23, color: "red", cursor: "pointer !important" }}
        className="pe-7s-note"
        onClick={() => {
          this.setState({ isShowUpdateNameAndReportDateModal: true });
        }}
      ></i>
    );
  };

  renderInputFileManagement = () => {
    return (
      <div>
        <div style={{ fontWeight: 500, marginBottom: "10px" }}>
          <a
            rel="tooltip"
            aria-disabled="true"
            className="btn btn-info btn-simple btn-xs"
            data-original-title="View Profile"
            onClick={() => {
              this.onDownloadInputFiles();
            }}
          >
            <i
              style={{ fontSize: 23, color: "red" }}
              className="pe-7s-download"
            ></i>
          </a>
          <span>Download selected files</span>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectInput("SELECT_ALL")}
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Input</th>
                <th>Uploader</th>
                <th>Upload Time</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstInput.map((item, index) => (
                <tr key={item.input}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.input}`}
                        onChange={() => this.onSelectInput(item.input)}
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.input}</td>
                  <td>{item.upload_by}</td>
                  <td>{item.upload_time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderOutputFileManagement = () => {
    return (
      <div>
        <div style={{ fontWeight: 500, marginBottom: "10px" }}>
          <a
            rel="tooltip"
            aria-disabled="true"
            className="btn btn-info btn-simple btn-xs"
            data-original-title="View Profile"
            onClick={() => {
              this.onDownloadOutputFiles();
            }}
          >
            <i
              style={{ fontSize: 23, color: "red" }}
              className="pe-7s-download"
            ></i>
          </a>
          <span>Download selected files</span>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectOutput("SELECT_ALL")}
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Output</th>
                <th>CreatedTime</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstOutput.map((item, index) => (
                <tr key={item.report_name}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.report_name}`}
                        onChange={() => this.onSelectOutput(item.report_name)}
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.report_name}</td>
                  <td>{item.created}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderIntermediateOutputFileManagement = () => null;

  render() {
    if (this.state.loading || this.state.downloadProgressMessage)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" message={this.state.downloadProgressMessage} />
        </div>
      );
    const lstMenuScenario = [];
    for (let e in dicScenario) {
      lstMenuScenario.push(
        <MenuItem
          onSelect={(eventKey, event) => {
            this.handleSelectScenario(eventKey, event);
          }}
          eventKey={e}
        >
          {dicScenario[e]}
        </MenuItem>,
      );
      lstMenuScenario.push(<MenuItem divider />);
    }
    return (
      <div className="card">
        <div
          className="header"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {this.state.fileInfo.status &&
            this.state.fileInfo.status !==
              Business.ENUMS.FILE_STATUS.CALCULATED &&
            this.state.fileInfo.status !==
              Business.ENUMS.FILE_STATUS.CALCULATING &&
            this.renderBtnUpdateNameAndReportDate()}
          <h4 className="title">{`${
            this.state.reportDate || ""
          } # ${Business.convertReportName(
            this.state.reportName || "",
            "ICAAP",
          )} # ${this.state.status || ""}`}</h4>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          {(() => {
            const isResultScreen = this.state.hasResult;
            return (
              <div>
                {this.renderUpdateNameAndReportDateModal()}
                {isResultScreen ? (
                  this.renderResult()
                ) : (
                  <div>
                    {this.renderInputFileManagement()}

                    {this.state.lstOutput.length > 0 &&
                      this.renderOutputFileManagement()}

                    {console.log(
                      `${this.state.reportName} | file info status: ${this.state.fileInfo.status} | lst output length: ${this.state.lstOutput.length}`,
                    )}

                    <div>
                      <FormGroup controlId="formControlsTextarea">
                        <label htmlFor="exampleInputEmail1">Reason for rejection: </label>
                        <FormControl
                          style={{ height: "100px", resize: "none" }}
                          disabled={this.state.isDisableReasonInput}
                          componentClass="textarea"
                          value={this.state.reason}
                          placeholder="Type your reason here..."
                          onChange={(event) => {
                            this.setState({ reason: event.target.value });
                          }}
                        />
                      </FormGroup>
                      <div style={{ display: "inline" }}>
                        <button
                          type="button"
                    disabled={
                      this.state.progressValue > 0 ||
                      this.state.isDisableRejectButton
                    }
                    className="btn btn-primary"
                    style={{
                      backgroundColor: "rgb(255 0 0)",
                      borderColor: "rgb(255 255 255)",
                      borderRadius: "5px",
                      fontWeight: 600,
                      marginLeft: "auto",
                      float: "left",
                      color: "white",
                    }}
                    onClick={() => {
                      this.onReject();
                    }}
                  >
                    Reject
                  </button>
                  <div style={{ display: "flex", float: "right" }}>
                    <button
                      type="button"
                      disabled={
                        this.state.progressValue > 0 ||
                        this.state.isDisableApprovalButton ||
                        !Business.isHasRole([
                          Business.ROLE_DEFINE_MAP.ICAAP_APPROVAL_FILES,
                        ])
                      }
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "#FFE600",
                        borderColor: "#7F7E82",
                        borderRadius: "5px 0px 0px 5px",
                        fontWeight: 600,
                      }}
                      onClick={() => {
                        this.onApproval();
                      }}
                    >
                      Approval
                    </button>
                    <button
                      type="button"
                      disabled={
                        this.state.progressValue > 0 ||
                        this.state.isDisableCalculateButton ||
                        !Business.isHasRole([
                          Business.ROLE_DEFINE_MAP.ICAAP_CALCULATE,
                        ])
                      }
                      className="btn btn-primary"
                      style={{
                        backgroundColor: "rgb(0 255 90)",
                        borderColor: "#7F7E82",
                        borderRadius: "0px 5px 5px 0px",
                        fontWeight: 600,
                      }}
                      onClick={() => {
                        this.onCalculate();
                      }}
                    >
                      Calculate
                    </button>
                  </div>
                </div>
              </div>
              {this.state.errorCode === ErrorCode.PendingBatchProcessing &&
                this.renderPendingBatchProcessing()}
            </div>
          )}
              </div>
            );
          })()}
        </div>
        <Alert
          title="Are you sure?"
          text="You will not be able to undo!"
          show={this.state.showRejectAlert}
          showCancelButton
          onConfirm={() => {
            this.onConfirmReject();
          }}
          onCancel={() => {
            this.setState({ showRejectAlert: false });
          }}
        />
        <Alert
          title="Some files failed to download!"
          text={`Please check the following files: ${this.state.failedDownloadsList.join(
            ", ",
          )}`}
          show={this.state.showFileDownloadError}
          onConfirm={() => {
            this.setState({ showFileDownloadError: false });
          }}
        />
      </div>
    );
  }
}

const style = {
  bolder: {
    fontWeight: 600,
  },
};

let lstIntervalDownload = [];
function clearGetBatchDownloadInterval() {
  lstIntervalDownload.forEach((id) => {
    clearInterval(id);
    console.warn(`${id} | Received state: STOP`);
  });
}

async function handleBatchDownload(
  fileInfo,
  lstFileSelected,
  reportDate,
  reportName,
  type,
  component,
  cb,
) {
  try {
    const fileArr = (lstFileSelected || []).map((name) =>
      Http.makeDownloadFileInfo(
        name,
        reportDate,
        reportName,
        type,
        component,
      ),
    );
    const result = await Http.downloadAllFiles(fileArr, reportDate, reportName);
    cb && cb();

    if (result && result.is_error) {
      Business.showAlert({
        title: "Error",
        content: "Some files failed to download",
      });
    }
  } catch (error) {
    console.error(`handleBatchDownload - catch error: ${error.message}`);
    cb && cb();
    Business.showAlert({ title: "Error", content: "Download failed" });
  }
}

const lstIntervalId = [];
function clearGetBatchResponseInterval(reportName) {
  lstIntervalId.forEach((intervalId) => clearInterval(intervalId));
  console.warn(`${reportName} | Received state: STOP`);
}

function toPercentValue(value) {
  if (value == null || value === undefined) return "";
  return `${(value * 100).toLocaleString("en-GB")}%`;
}

function toAmountValue(value) {
  if (value == null || value === undefined) return "";
  return `${value.toLocaleString("en-GB")}`;
}

const DEFAULT_REPORT = {
  rwa_e: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_cr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_or: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_mr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_cor: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_irrbb: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_omr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //delta
  delta_rwa: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_cr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_or: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_mr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_cor: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_irrbb: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_omr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Von tu co
  von_tu_co_ca: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Von yeu cau
  von_yeu_cau_cr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Von kinh te
  von_kinh_te_ce: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Thue suat
  corp_tax: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Delta PNL
  delta_pnl: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  thay_doi_thu_nhap_lai: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  thay_doi_chi_phi_du_phong: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  thay_doi_thu_nhap_tu_rui_ro_thi_truong: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ton_that_rui_ro_hoat_dong: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  chi_phi_thanh_khoan: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_an_toan_von_car: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_an_toan_von_cap_1_ct1: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_an_toan_von_chu_so_huu_cap_1_cet1: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_don_bay: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  roe: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  raroc: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
};

export default FileInfo;



// WEBPACK FOOTER //
// src/pages/LiquidityRatio/LCR/FileManagement/FileInfo.js